import React, { useState } from 'react';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';
import DoneIcon from '@mui/icons-material/Done';
import { useLayoutContext } from '../../../Context/Layout.context';
import { Prompt, SubText } from '../../../components/Prompt/Prompt.component';
import { countryCoordinatorApproveExamTaskGroupSolutionScore } from '../../../services/scoringModel/scoringModel.service';
import {
  CoordinatorApproveExamTaskGroupSolutionScoreResponse,
  ExamTaskgroupSolutionScoreApprovalCoordinator,
} from '../../../services/scoringModel/scoringModel.types';
import { Link } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { getAssessmentSampleAssessmentGroupSolutionUrl } from '../../../utils/routerUrls';
import { TableSelection } from '../../../components/SelectableTable/SelectableTable.types';
import { SelectedRecordCountDisplay } from '../../../components/SelectableTable/SelectedRecordCountDisplay/SelectedRecordCountDisplay.component';

interface CoordinatorConfirmationProps {
  isVisible: boolean;
  totalItems: number;
  selection: TableSelection;
  reload: () => void;
}

export const CoordinatorConfirmation: React.FC<CoordinatorConfirmationProps> = ({
  isVisible,
  selection,
  totalItems,
  reload,
}) => {
  const [isPromptOpen, setIsPromptOpen] = useState<boolean>(false);
  const [promptType, setPromptType] = useState<'success' | 'error' | 'confirmation'>('success');
  const [promptMainText, setPromptMainText] = useState<string>('');
  const [promptSubTexts, setPromptSubTexts] = useState<SubText[]>([]);

  const { showLoader } = useLayoutContext();
  const handleOnClick = () => {
    showLoader(true, 'Zatwierdzam RGZ');

    countryCoordinatorApproveExamTaskGroupSolutionScore(selection.items, !!selection.isAll)
      .then((response: AxiosResponse<ExamTaskgroupSolutionScoreApprovalCoordinator>) => {
        const result = response.data.examTaskGroupSolutionScoreApprovalResultDtos;
        const countTotal = result.length;
        const failedRgz = result.filter(
          (e) =>
            e.approveMultipleExamTaskGroupSolutionScoreResponse !==
            CoordinatorApproveExamTaskGroupSolutionScoreResponse.Success,
        );
        if (
          result.every(
            (e) =>
              e.approveMultipleExamTaskGroupSolutionScoreResponse ===
              CoordinatorApproveExamTaskGroupSolutionScoreResponse.Success,
          )
        ) {
          const successCount = result.length;
          setPromptType('success');
          setPromptMainText(`${successCount} z ${successCount}`);
          setPromptSubTexts([{ text: 'Rozwiązania Grupy Zadań zostały pomyślnie zatwierdzone.' }]);
          setIsPromptOpen(true);
        } else {
          const countSuccess = result.length - failedRgz.length;

          const failed = failedRgz.map((item) => {
            return {
              inlineLink: (
                <Link
                  to={getAssessmentSampleAssessmentGroupSolutionUrl(
                    item.schoolId,
                    item.examTaskGroupSolutionId,
                    item.examTaskGroupSolutionScoreId,
                    item.examinerId,
                    '0',
                  )}
                >
                  {item.examTaskGroupSolutionScoreId}
                </Link>
              ),
            };
          });

          setPromptType('confirmation');
          setPromptMainText(`${countSuccess} z ${countTotal}`);
          setPromptSubTexts([
            { text: 'Rozwiązania Grupy Zadań zostały pomyślnie zatwierdzone.' },
            { text: 'RGZ:', isBold: true },
            ...failed,
            {
              text: 'nie może zostać zatwierdzone, ponieważ nie zostało zaakceptowane przez PZWO, zostało uprzednio zatwierdzone lub nie uzupełniono wymuszonego komentarza.',
            },
          ]);
          setIsPromptOpen(true);
        }
      })
      .catch(() => {
        setPromptType('error');
        setPromptMainText('Zatwierdzenie wybranych RGZ nie powiodło się, spróbuj ponownie później.');
        setPromptSubTexts([]);
        setIsPromptOpen(true);
      })
      .finally(() => {
        showLoader(false);
      });
  };

  return (
    <>
      {isVisible && (
        <div style={{ marginLeft: '-23px' }}>
          <SelectedRecordCountDisplay selection={selection} totalItems={totalItems}>
            <ButtonOne
              startIcon={<DoneIcon />}
              variant="contained"
              style={{ color: 'white', width: 170, height: 30, backgroundColor: '#347F42' }}
              onClick={handleOnClick}
            >
              Zatwierdź RGZ
            </ButtonOne>
          </SelectedRecordCountDisplay>
        </div>
      )}
      <Prompt
        isBold={true}
        type={promptType}
        open={isPromptOpen}
        mainText={promptMainText}
        subTexts={promptSubTexts}
        mainActionButtonText={'powrót do listy'}
        onConfirm={() => {
          {
            setIsPromptOpen(false);
            reload();
          }
        }}
      />
    </>
  );
};
